class Storage {
  storage: Record<string, string> = {};

  setItem = (key: string, value: string): void => {
    this.storage[key] = value || '';
  };

  getItem = (key: string): string | null => this.storage[key] || null;

  removeItem = (key: string): void => {
    delete this.storage[key];
  };
}

const storageMock = new Storage();

export const storage = {
  setItem: (key: string, value: string): void => {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem(key, value);
    } else {
      storageMock.setItem(key, value);
    }
  },
  getItem: (key: string): string | null => {
    if (typeof window !== 'undefined') {
      return sessionStorage.getItem(key);
    } else {
      return storageMock.getItem(key);
    }
  }
};

export const appLocalStorage = {
  setItem: (key: string, value: string): void => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(key, value);
    } else {
      storageMock.setItem(key, value);
    }
  },
  getItem: (key: string): string | null => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem(key);
    } else {
      return storageMock.getItem(key);
    }
  },
  removeItem: (key: string): void => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(key);
    } else {
      storageMock.removeItem(key);
    }
  }
};
